import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitsService {


  constructor(
    private http: HttpClient
  ) { }

  url = environment.serverAPI5 + "/api/units";

  searchUnits(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getUnits(Page: number, size: number, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllUnitsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  CreateUnits(units: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, units)
  }

  getUnitsById(Id: number): Observable<Object> {
    return this.http.get(`${this.url}/${Id}`);
  }
  deleteByUnitsId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}
  downloadCategoriesTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
  }
  downloadUnitsReport(Page: number, size: number, sort,selectionUnits): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionUnits, { 
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  /** Returns pharmacy unit types: STR, TAB, CAP, BTL, TUBE, VIAL, AMP, BOX */
  getPharmacyUnits(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/pharmacy`);
  }

  syncUnitsPageData(): Observable<any> {
    return this.http.get(`${this.url}/page/sync`);
  }
}

